export function counterproposalWithoutDates2025() {
return [   //2024 Release 2025-08-30 12:40:09
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 183.96,
   left: 398.64,
   width: 176.04,
   height: 12.84
}
,
{
   page: 0,
   name: "date contract", 
   fontSize: 9,
   type: "date",
   top: 220.08,
   left: 109.2,
   width: 144.96,
   height: 12.84
}
,
{
   page: 0,
   name: "seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 233.76,
   left: 50.28,
   width: 489.96,
   height: 12.84
}
,
{
   page: 0,
   name: "and", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 247.68,
   left: 67.2,
   width: 475.08,
   height: 12.84
}
,
{
   page: 0,
   name: "county", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 261.36,
   left: 430.92,
   width: 145.08,
   height: 12.84
}
,
{
   page: 0,
   name: "known as", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.32,
   left: 96,
   width: 433.68,
   height: 12.84
}
,
{
   page: 0,
   name: "Text1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 289.965,
   left: 49.7457,
   width: 527.0203,
   height: 111.018
}
,
{
   page: 0,
   name: "Text2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 546.548,
   left: 48.4366,
   width: 523.0924,
   height: 84.182
}
,
{
   page: 0,
   name: "Text3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 648.657,
   left: 49.7457,
   width: 523.7473,
   height: 107.7462
}
,
{
   page: 1,
   name: "Date_2", 
   fontSize: 9,
   type: "date",
   top: 655.898,
   left: 48.96,
   width: 75.00,
   height: 15.862
}
,
{
   page: 1,
   name: "Time", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 655.898,
   left: 131.52,
   width: 60.00,
   height: 15.862
}
,
{
   page: 1,
   name: "Text4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 57.6,
   left: 54.9821,
   width: 513.2739,
   height: 560.039
}
,
{
   page: 2,
   name: "Buyers Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 102.785,
   left: 50.3342,
   width: 253.1458,
   height: 22.659
}
,
{
   page: 2,
   name: "Address 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 162.6,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Address 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 176.04,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Phone No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 189.48,
   left: 121.68,
   width: 181.80,
   height: 10.92
}
,
{
   page: 2,
   name: "Fax No", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 201.96,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Email Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 215.4,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Sellers Name 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 254.68,
   left: 49.6797,
   width: 253.8003,
   height: 22.658
}
,
{
   page: 2,
   name: "Address 1_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 316.16,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Address 2_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.84,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Phone No_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 343.28,
   left: 121.68,
   width: 181.80,
   height: 10.92
}
,
{
   page: 2,
   name: "Fax No_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 354.8,
   left: 121.68,
   width: 181.80,
   height: 12.6
}
,
{
   page: 2,
   name: "Email Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 368.0,
   left: 121.68,
   width: 181.80,
   height: 12.84
}
,
{
   page: 2,
   name: "Buyers Name_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 102.44,
   left: 324.654,
   width: 251.706,
   height: 22.658
}
,
{
   page: 2,
   name: "Address 1_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 162.6,
   left: 396,
   width: 180.36,
   height: 12.84
}
,
{
   page: 2,
   name: "Address 2_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 177.24,
   left: 396,
   width: 180.24,
   height: 12.84
}
,
{
   page: 2,
   name: "Phone No_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 190.68,
   left: 396,
   width: 180.36,
   height: 10.68
}
,
{
   page: 2,
   name: "Fax No_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 201.96,
   left: 396,
   width: 180.36,
   height: 12.84
}
,
{
   page: 2,
   name: "Email Address_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 215.4,
   left: 396,
   width: 180.36,
   height: 12.84
}
,
{
   page: 2,
   name: "Sellers Name 1_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 254.68,
   left: 322.691,
   width: 253.669,
   height: 23.313
}
,
{
   page: 2,
   name: "Address 1_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 316.16,
   left: 396.72,
   width: 179.64,
   height: 12.84
}
,
{
   page: 2,
   name: "Address 2_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.84,
   left: 396.24,
   width: 180.12,
   height: 12.84
}
,
{
   page: 2,
   name: "Phone No_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 343.28,
   left: 396.72,
   width: 179.64,
   height: 10.92
}
,
{
   page: 2,
   name: "Fax No_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 354.8,
   left: 396.72,
   width: 179.64,
   height: 12.6
}
,
{
   page: 2,
   name: "Email Address_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 368.0,
   left: 396.24,
   width: 180.12,
   height: 12.84
}
,
{
   page: 2,
   name: "Text5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 420.22,
   left: 47.1275,
   width: 254.0735,
   height: 22.00
}
,
{
   page: 2,
   name: "Text6", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 420.22,
   left: 321.383,
   width: 251.455,
   height: 22.00
}
] }
